import React, { createContext, useState, useEffect } from "react";

export const HashContext = createContext();

export const HashProvider = ({ children }) => {
  const [routeId, setRouteId] = useState(window.location.hash);

  // Extract hash from URL and listen for changes
  useEffect(() => {
    const handleHashChange = () => {
      setRouteId(window.location.hash);
    };

    // Set initial hash
    if (window.location.hash) {
      setRouteId(window.location.hash);
    }

    // Subscribe to hash changes
    window.addEventListener("hashchange", handleHashChange);

    // Cleanup function
    return () => {
      window.removeEventListener("hashchange", handleHashChange);
    };
  }, []);

  return (
    <HashContext.Provider value={routeId}>{children}</HashContext.Provider>
  );
};
